// Vendor Management Types

export enum VendorStatus {
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
  SUSPENDED = "SUSPENDED",
  ACTIVE = "ACTIVE",
}

export interface Vendor {
  id: string;
  vendorCode: string;
  name: string;
  phone: string;
  email?: string;
  city?: string;
  state?: string;
  pincode?: string;
  address?: string;
  aadhaar?: string;
  pan?: string;
  aadhaarUrl?: string;
  aadhaarS3Key?: string;
  panUrl?: string;
  panS3Key?: string;
  operatingCities: string[];
  territoryAssigned?: string;
  status: VendorStatus;
  isVerified: boolean;
  verifiedAt?: Date;
  verifiedBy?: string;
  suspendedAt?: Date;
  suspendedBy?: string;
  suspensionReason?: string;
  totalReferrals: number;
  convertedReferrals: number;
  conversionRate: number;
  totalCommissionEarned: number;
  pendingCommission: number;
  paidCommission: number;
  bankAccountHolder?: string;
  bankAccountNumber?: string;
  bankIfscCode?: string;
  bankName?: string;
  bankBranch?: string;
  bankProofUrl?: string;
  notes?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateVendorDTO {
  name: string;
  phone: string;
  email?: string;
  city?: string;
  state?: string;
  pincode?: string;
  address?: string;
  aadhaar?: string;
  pan?: string;
  operatingCities?: string[];
  territoryAssigned?: string;
  aadhaarUrl?: string;
  aadhaarS3Key?: string;
  panUrl?: string;
  panS3Key?: string;
}

export interface UpdateVendorDTO {
  name?: string;
  email?: string;
  city?: string;
  state?: string;
  pincode?: string;
  address?: string;
  operatingCities?: string[];
  territoryAssigned?: string;
  notes?: string;
  aadhaarUrl?: string;
  aadhaarS3Key?: string;
  panUrl?: string;
  panS3Key?: string;
}

export interface VendorBankDetailsDTO {
  bankAccountHolder: string;
  bankAccountNumber: string;
  bankIfscCode: string;
  bankName: string;
  bankBranch?: string;
  bankProofUrl?: string;
}

export interface VendorPerformance {
  vendorId: string;
  vendorName: string;
  totalReferrals: number;
  conversionsByStage: {
    registered: number;
    kycVerified: number;
    firstDelivery: number;
    retained: number;
  };
  conversionRate: number;
  totalCommissionEarned: number;
  pendingCommission: number;
  paidCommission: number;
  averageTimeToConversion: number;
  topPerformingCities: Array<{
    city: string;
    count: number;
  }>;
}

export interface VendorFilterParams {
  page?: number;
  limit?: number;
  status?: VendorStatus;
  city?: string;
  search?: string;
  isVerified?: boolean;
}
